import React from "react";
import "../App.css";
import HeroSection from "../components/HeroSection/HeroSection";
import Cards from "../components/Cards/Cards";
import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation();

  return (
    <>
      <HeroSection />

      <section className="home-trustbar">
        <div className="home-trustbar-item">
          <strong>{t("trustbar.app.title")}</strong>
          <span>{t("trustbar.app.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.free.title")}</strong>
          <span>{t("trustbar.free.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.cross.title")}</strong>
          <span>{t("trustbar.cross.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.dsgvo.title")}</strong>
          <span>{t("trustbar.dsgvo.description")}</span>
        </div>
      </section>
      <Cards />
    </>
  );
}

export default Home;
